<script setup lang="ts">
import { BackgroundTiles } from '~/lib/services/content/content.blocks.dtos'

defineProps<{
  block: BackgroundTiles
}>()
const isMobile = inject('isMobile')
</script>

<template>
  <div
    class="flex flex-col items-center justify-center gap-6 md:mt-5 md:flex-row md:flex-wrap md:gap-2 md:px-5 lg:flex-row lg:px-14"
  >
    <section
      v-for="tile in block.backgroundTiles"
      :key="tile.id"
      class="relative h-[504px] max-w-[360px] lg:h-[600px] lg:max-w-[424px]"
    >
      <img
        class="absolute z-0 h-full w-full object-cover"
        :src="isMobile ? tile.imageMobile.url : tile.imageDesktop.url"
        :alt="
          (isMobile ? tile.imageMobile.alternativeText : tile.imageDesktop.alternativeText) ||
          undefined
        "
        :title="
          (isMobile ? tile.imageMobile.alternativeText : tile.imageDesktop.alternativeText) ||
          'undefined'
        "
      />
      <div class="relative z-[9] flex h-full flex-col justify-end px-4 py-8 lg:px-12 lg:py-14">
        <header class="flex flex-col gap-4">
          <h2 class="text-lg font-bold leading-6 tracking-[-0.15px] lg:text-2xl lg:leading-8">
            {{ tile.title }}
          </h2>
          <p class="text-sm leading-4 tracking-[-0.15px]">{{ tile.content }}</p>
          <SimpleLink v-if="tile.tertiaryBtn" :link="tile.tertiaryBtn">
            <div class="flex gap-2 text-mcd-secondaryBlue">
              <p>{{ tile.tertiaryBtn?.title }}</p>
              <img src="/images/icons/arrowRightBlue.svg" alt="left" />
            </div>
          </SimpleLink>
        </header>

        <footer v-if="tile.primaryBtn || tile.secondaryBtn" class="mt-8 grid grid-cols-2 gap-6">
          <SimpleLink v-if="tile.primaryBtn" :link="tile.primaryBtn">
            <McdButton class="h-10 w-full" is-primary>{{ tile.primaryBtn?.title }}</McdButton>
          </SimpleLink>
          <SimpleLink v-if="tile.secondaryBtn" :link="tile.secondaryBtn">
            <McdButton class="h-10 w-full" is-secondary>{{ tile.secondaryBtn?.title }}</McdButton>
          </SimpleLink>
        </footer>
      </div>
    </section>
  </div>
</template>
